<template>
    <section class="wrapper">
        <div class="contact-banner" id="contactBanner">
            <div class="contact-banner__logo">
                <img 
                    class="contact-banner__img" 
                    src="@/assets/img/banner/garlasllc-banner-tittle.svg" 
                    alt="Garlas Logo"
                    @error="handleImageError"
                    v-if="!imageError"
                >
                <div v-else class="contact-banner__fallback-logo">
                    Garlas LLC
                </div>
            </div>
            <div class="contact-banner__container">
                <h2 class="contact-banner__title">{{ $t('garlasContactBanner.title') || 'Official Contact' }}</h2>
                <div class="contact-banner__contact">
                    <div>
                        <p class="contact-banner__email">{{ $t('garlasContactBanner.emailLabel') || 'Email:' }} </p>
                        <p class="contact-banner__email">
                            <a href="mailto:garlas.llc@gmail.com">garlas.llc@gmail.com</a>
                        </p>
                    </div>
                    <div>
                        <p class="contact-banner__phone">{{ $t('garlasContactBanner.phoneLabel') || 'Phone:' }}</p>
                        <p class="contact-banner__phone">
                            <a href="tel:+18704556742">+1-870-455-6742</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref } from 'vue'

const imageError = ref(false)

const handleImageError = () => {
    imageError.value = true
}
</script>

<style scoped>
.contact-banner {
    display: flex;
    place-content: center;
    width: min-content;
    height: fit-content;
    background-color: #F5F5F5;
    gap: 3vw;
    border-radius: 1.3vw;
    margin: 4rem auto 10rem auto;
    padding-block: 7vh;
    padding-inline: 8vw;
}

.contact-banner__img {
    max-width: fit-content;
    margin: 0;
    width: auto;
    height: 70px;
}

.contact-banner__fallback-logo {
    font-size: 2rem;
    font-weight: bold;
    color: var(--SecondaryColor);
    text-align: center;
    padding: 1rem;
}

.contact-banner__container {
    display: flex;
    align-items: flex-start;
    text-wrap: nowrap;
    width: 100%;
    display: flex;
    flex-direction: column;
}

.contact-banner__logo {
    display: flex;
    align-items: center;
    justify-content: center;
}

.contact-banner__title {
    font-size: 2.8rem;
    color: var(--SecondaryColor);
    text-align: center;
    margin-bottom: 1rem;
}

.contact-banner__contact {
    margin: 0;
    font-size: 2.2rem;
    color: var(--SecondaryColor);
}

.contact-banner__contact div {
    display: flex;
    gap: 0.5rem;
}

.contact-banner__contact div > p:first-child {
    font-weight: 500;
}

@media only screen and (max-width: 770px) {
    .wrapper {
        display: flex;
        width: 100%;
    }

    .contact-banner {
        padding-block: 10vh;
        flex-direction: column;
        align-items: center;
        gap: 6rem;
        width: 100%;
        display: flex;
        border-radius: 25px;
    }

    .contact-banner__container, .contact-banner__contact > div {
        align-items: center;
        text-align: center;
        gap: 1rem;
        justify-content: center;
    }

    .contact-banner__contact {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        font-size: 2rem;
    }

    .contact-banner__title {
        font-size: 3.2rem;
    }

    .contact-banner__fallback-logo {
        font-size: 1.5rem;
    }
}
</style> 